// react
import styled from 'styled-components';

// components
import { Card, Container, Title } from '@/components/atoms';

interface AttendanceAllowanceHeroProps {
  eligibilityCalculator?: React.ReactNode;
  careRecipientName?: string;
}

/**
 * AttendanceAllowanceHero introduces the care plan.
 */
export const AttendanceAllowanceHero = ({
  eligibilityCalculator,
  careRecipientName = 'your loved one',
}: AttendanceAllowanceHeroProps) => {
  return (
    <Container size='lg' isNoPadding>
      {eligibilityCalculator && (
        <>
          <StyledTitle>Check if {careRecipientName} is eligible</StyledTitle>
          <Card isNoPadding>{eligibilityCalculator}</Card>
        </>
      )}
      <StyledTitle>Information you need</StyledTitle>
      <List>
        <ListItem>
          <Strong>Personal details:</Strong> full name, address, date of birth,
          National Insurance number (if they have one), and contact information.
        </ListItem>
        <ListItem>
          <Strong>Medical information:</Strong> medical condition(s), including
          any diagnoses, treatments, medications, and how their condition
          affects their ability to carry out daily tasks.
        </ListItem>
        <ListItem>
          <Strong>Care needs:</Strong> Describe the specific care needs,
          including assistance with tasks like bathing, dressing, eating,
          mobility, and managing medication.
        </ListItem>
      </List>
    </Container>
  );
};

const StyledTitle = styled(Title)`
  color: ${(props) => props.theme.color.neutral[100]};
  margin-top: ${(props) => props.theme.spacing[32]};
  font: ${(props) => props.theme.typography.body.xl.medium};
`;

const List = styled.ol`
  padding-left: 20px;
  padding-bottom: ${(props) => props.theme.spacing[24]};
`;

const ListItem = styled.li`
  margin-bottom: 20px;
  font: ${(props) => props.theme.typography.body.lg.regular};
  color: ${(props) => props.theme.color.neutral[80]};
`;

const Strong = styled.strong`
  font: ${(props) => props.theme.typography.body.lg.semibold};
`;

AttendanceAllowanceHero.displayName = 'AttendanceAllowanceHero';

export default AttendanceAllowanceHero;
